/* AirPods-generatiefinder (generatiepagina + AirPods-producttemplates). Eén bron sinds 02-10-2026.
   Modelnummers volgens Apple "Je AirPods identificeren" (support.apple.com/nl-nl/109525, gelezen 02-10-2026).
   vt = tekst in de varianttitel van het product; dan linkt de knop met ?variant=, anders kiest de
   productpagina zelf de variant met voorraad (rw-prefer-stock) en kan dat de verkeerde uitvoering zijn. */
(function(){
  /* Families & codes (incl. CASE mapping) */
  const FAMILIES = {
    PRO3:  { labelEar:"AirPods Pro (3e generatie)", labelCase:"AirPods Pro (3e generatie)",
             earbuds:["A3063","A3064","A3065"], cases:["A3122"] },
    PRO2_USBC: { labelEar:"AirPods Pro (2e generatie) met USB-C-case", labelCase:"AirPods Pro (2e generatie) met USB-C-case",
             earbuds:["A3047","A3048","A3049"], cases:["A2968"], vt:"USB-C" },
    PRO2_LIGHTNING: { labelEar:"AirPods Pro (2e generatie) met Lightning-case", labelCase:"AirPods Pro (2e generatie) met Lightning-case",
             earbuds:["A2931","A2699","A2698"], cases:["A2700"], vt:"Lightning" },
    PRO1:  { labelEar:"AirPods Pro",                labelCase:"AirPods Pro",
             earbuds:["A2084","A2083"], cases:["A2190"] },
    AP5_WCC:{ labelEar:"AirPods (5e generatie) (draadloze oplaadcase)", labelCase:"AirPods (5e generatie) (draadloze oplaadcase)",
             earbuds:["A3439","A3440","A3441"], cases:["A3529"], vt:"Met draadloze oplaadcase" },
    AP5:   { labelEar:"AirPods (5e generatie) (USB-C-oplaadcase)", labelCase:"AirPods (5e generatie) (USB-C-oplaadcase)",
             earbuds:["A3531","A3532","A3533"], cases:["A3530"], vt:"Met USB-C-oplaadcase" },
    AP4_ATC:{labelEar:"AirPods (4e generatie) (met ANC)", labelCase:"AirPods (4e generatie) (met ANC)",
             earbuds:["A3056","A3055","A3057"], cases:["A3059"], vt:"Met Active Noise Canceling" },
    AP4:   { labelEar:"AirPods (4e generatie) (zonder ANC)", labelCase:"AirPods (4e generatie) (zonder ANC)",
             earbuds:["A3053","A3050","A3054"], cases:["A3058"], vt:"Zonder Active Noise Canceling" },
    AP3:   { labelEar:"AirPods (3e generatie)",     labelCase:"AirPods (3e generatie) met Lightning-case",
             earbuds:["A2565","A2564"], cases:["A2897"] },
    AP3_MAGSAFE: { labelEar:"AirPods (3e generatie)", labelCase:"AirPods (3e generatie) met MagSafe-case",
             earbuds:[], cases:["A2566"] },
    AP2:   { labelEar:"AirPods (2e generatie)",     labelCase:"AirPods (1e en 2e generatie)",
             earbuds:["A2032","A2031"], cases:["A1602","A1938"] },
    AP1:   { labelEar:"AirPods (1e generatie)",     labelCase:"AirPods (1e en 2e generatie)",
             earbuds:["A1523","A1722"], cases:["A1602","A1938"] }
  };

  const CODE_TO_FAMILY = {};
  Object.entries(FAMILIES).forEach(([k,f])=>{
    f.earbuds.forEach(c=>CODE_TO_FAMILY[c]=k);
    f.cases.forEach(c=>{ if(!CODE_TO_FAMILY[c]) CODE_TO_FAMILY[c]=k; }); /* A1602/A1938 blijven AP2, niet AP1 */
  });
  /* P1-geen-stille-voorkeuze: op-polish.js zet hieruit de modelnummers onder de uitvoeringsknoppen */
  window.OP_AIRPODS_FAMILIES = FAMILIES;

  /* Directe product-URLs per familie/zijde/case (pas aan indien nodig) */
  const PRO2_URLS = { left:"/products/airpods-pro-2e-generatie-links-vervangend-linker-oortje",
            right:"/products/airpods-pro-2e-generatie-rechts-vervangend-rechter-oortje",
            case:"/products/airpods-pro-2e-generatie-charging-case-oplaadcase" };
  const PRODUCT_URL = {
    PRO3: { left:"/products/apple-airpods-pro-3e-generatie-links-vervangend-linker-oortje",
            right:"/products/apple-airpods-pro-3e-generatie-rechts-vervangend-rechter-oortje",
            case:"/products/apple-airpods-pro-3-charging-case-oplaadcase" },
    PRO2_USBC: PRO2_URLS,
    PRO2_LIGHTNING: PRO2_URLS,
    PRO1: { left:"/products/airpods-pro-links-vervangend-linker-oortje",
            right:"/products/airpods-pro-rechts-vervangend-rechter-oortje",
            case:"/products/airpods-pro-charging-case-oplaadcase" },
    AP5_WCC: { left:"/products/airpods-5e-generatie-links-vervangend-linker-oortje",
               right:"/products/airpods-5e-generatie-rechts-vervangend-rechter-oortje",
               case:"/products/airpods-5e-generatie-charging-case-oplaadcase" },
    AP5: { left:"/products/airpods-5e-generatie-links-vervangend-linker-oortje",
           right:"/products/airpods-5e-generatie-rechts-vervangend-rechter-oortje",
           case:"/products/airpods-5e-generatie-charging-case-oplaadcase" },
    AP4_ATC: { left:"/products/airpods-4e-generatie-links-vervangend-linker-oortje",
               right:"/products/airpods-4e-generatie-rechts-vervangend-rechter-oortje",
               case:"/products/airpods-4e-generatie-charging-case-oplaadcase" },
    AP4: { left:"/products/airpods-4e-generatie-links-vervangend-linker-oortje",
           right:"/products/airpods-4e-generatie-rechts-vervangend-rechter-oortje",
           case:"/products/airpods-4e-generatie-charging-case-oplaadcase" },
    AP3: { left:"/products/airpods-3e-generatie-links-vervangend-linker-oortje",
           right:"/products/airpods-3e-generatie-rechts-vervangend-rechter-oortje-1",
           case:"/products/airpods-3e-generatie-charging-case-oplaadcase-1" },
    AP3_MAGSAFE: { left:"/products/airpods-3e-generatie-links-vervangend-linker-oortje",
           right:"/products/airpods-3e-generatie-rechts-vervangend-rechter-oortje-1",
           case:"/products/apple-airpods-3e-generatie-magsafe-charging-case-oplaadcase" },
    AP2: { left:"/products/airpods-2e-generatie-links-vervangend-linker-oortje",
           right:"/products/airpods-2e-generatie-rechts-vervangend-rechter-oortje",
           case:"/products/airpods-2e-generatie-charging-case-oplaadcase" },
    /* AP1: oortjes NIET beschikbaar → case wél (AP2 case past) */
    AP1: { left:null, right:null, case:"/products/airpods-2e-generatie-charging-case-oplaadcase" }
  };

  /* DOM refs */
  const stepTxt = document.getElementById('pf-step');
  if(!stepTxt) return;
  const dots = [1,2,3].map(n=>document.getElementById('dot-'+n));
  const v1 = document.getElementById('view-1');
  const v2 = document.getElementById('view-2');
  const v3 = document.getElementById('view-3');
  const back2 = document.getElementById('back-2');
  const back3 = document.getElementById('back-3');
  const input = document.getElementById('pf-input');
  const btnSearch = document.getElementById('pf-search');
  const errorEl = document.getElementById('pf-error');

  const missOut = document.getElementById('pf-miss');
  const modelOut = document.getElementById('pf-model');
  const extraOut = document.getElementById('pf-extra');
  const restart = document.getElementById('pf-restart');
  const cta = document.getElementById('pf-cta');

  let missing = null; // 'L' | 'R' | 'CASE'
  let zoekSeq = 0;    // nieuwste zoekopdracht; een oud fetch-antwoord mag de knop niet meer zetten

  /* helpers */
  function goto(step){
    stepTxt.textContent = step;
    dots.forEach((d,i)=> d.classList.toggle('is-on', i < step));
    v1.style.display = step===1 ? '' : 'none';
    v2.style.display = step===2 ? '' : 'none';
    v3.style.display = step===3 ? '' : 'none';
  }
  function missLabel(code){
    if(code === 'L') return 'Linker oortje';
    if(code === 'R') return 'Rechter oortje';
    return 'Oplaadcase';
  }
  function normalize(val){
    if(!val) return '';
    val = String(val).trim().toUpperCase().replace(/\s+/g,'').replace(/-/g,'');
    const m = val.match(/^A\d{4}$/);
    return m ? m[0] : '';
  }
  function showError(msg){ errorEl.textContent = msg; errorEl.style.display = ''; }
  function clearError(){ errorEl.textContent = ''; errorEl.style.display = 'none'; }

  /* Zet ?variant= op de knop voor de uitvoering die bij het modelnummer hoort. */
  function kiesVariant(href, vt, mijn){
    cta.dataset.wacht = '1';
    cta.setAttribute('aria-disabled','true');
    cta.textContent = 'Even zoeken…';
    cta.href = '#'; /* geen kale productlink zolang het id er niet is (middelklik / nieuw tabblad) */
    function klaar(url){
      if(mijn !== zoekSeq) return;
      cta.href = url;
      delete cta.dataset.wacht;
      cta.removeAttribute('aria-disabled');
      cta.textContent = 'Bekijk product';
    }
    const haal = ()=>fetch(href + '.js', { headers: { Accept: 'application/json' } })
      .then(r=>{ if(!r.ok) throw new Error(String(r.status)); return r.json(); });
    haal().catch(haal) /* één herkansing: zonder id kiest de productpagina de variant met voorraad */
      .then(p=>{
        const v = p.variants.find(x=>x.title === vt) || p.variants.find(x=>x.title.indexOf(vt) >= 0);
        klaar(v ? href + '?variant=' + v.id : href);
      })
      .catch(()=>klaar(href));
  }
  cta.addEventListener('click', (e)=>{ if(cta.dataset.wacht) e.preventDefault(); });

  /* stap 1 */
  document.querySelectorAll('#view-1 .choice button').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      missing = btn.getAttribute('data-miss');
      goto(2);
      setTimeout(()=>input.focus(), 30);
    });
  });
  back2.addEventListener('click', (e)=>{ e.preventDefault(); goto(1); });
  back3.addEventListener('click', (e)=>{ e.preventDefault(); goto(2); });

  /* stap 2 -> 3 */
  function doSearch(){
    const mijn = ++zoekSeq;
    const key = normalize(input.value);
    missOut.textContent = missLabel(missing || 'L');

    if(!key){ showError('Modelnummer niet herkend. Probeer een ander modelnummer.'); return; }
    const famKey = CODE_TO_FAMILY[key];
    if(!famKey){ showError('Modelnummer niet herkend. Probeer een ander modelnummer.'); return; }

    clearError();

    const fam = FAMILIES[famKey];
    const urls = PRODUCT_URL[famKey] || {};
    const isCase = (missing === 'CASE');

    modelOut.textContent = isCase ? fam.labelCase : fam.labelEar;
    extraOut.style.display = 'none';
    if(!isCase && FAMILIES.AP1.cases.indexOf(key) >= 0){
      extraOut.textContent = 'Dit is het nummer van je case, die hoort bij AirPods 1 en 2. Dit oortje past alleen bij AirPods 2 (A2031 of A2032 op het oortje).';
      extraOut.style.display = '';
    }

    cta.classList.remove('btn--danger');
    cta.removeAttribute('aria-disabled');
    delete cta.dataset.wacht;

    if(famKey === 'AP1' && !isCase){
      // 1e generatie oortjes: niet beschikbaar
      cta.textContent = 'Geen product beschikbaar';
      cta.classList.add('btn--danger');
      cta.setAttribute('aria-disabled','true');
      cta.href = 'javascript:void(0)';
    }else{
      let href = "#";
      let direct = true;
      if(isCase) {
        href = urls.case || `/collections/all?q=${encodeURIComponent(fam.labelCase + ' case')}`;
        direct = !!urls.case;
      } else if(missing === 'L') {
        href = urls.left || `/collections/all?q=${encodeURIComponent(fam.labelEar + ' links')}`;
        direct = !!urls.left;
      } else {
        href = urls.right || `/collections/all?q=${encodeURIComponent(fam.labelEar + ' rechts')}`;
        direct = !!urls.right;
      }
      cta.href = href;
      cta.textContent = 'Bekijk product';
      if(fam.vt && direct) kiesVariant(href, fam.vt, mijn);
    }

    goto(3);
  }

  btnSearch.addEventListener('click', doSearch);
  input.addEventListener('keydown', (e)=>{ if(e.key==='Enter'){ e.preventDefault(); doSearch(); } });
  input.addEventListener('input', ()=>{ if(errorEl.style.display!=='none'){ clearError(); } });

  /* reset */
  restart.addEventListener('click', ()=>{ zoekSeq++; input.value=''; missing=null; clearError(); goto(1); });

  // init
  goto(1);
})();
